import React from 'react';
import PropTypes from 'prop-types';

const FiletypeVideoPath = ({ fill = '#FF6300' }) => {
  return (
    <path
      fill={fill}
      d="M7.701 4h10.717c.54 0 1.261.293 1.639.654l5.259 5.027c.382.366.684 1.082.684 1.609v15.084c0 .898-.762 1.626-1.701 1.626H7.701C6.762 28 6 27.272 6 26.374V5.626C6 4.728 6.763 4 7.701 4zM12 19.999c0 .779.575 1.309 1.245 1.309.225 0 .461-.06.689-.19l6.124-3.5c.906-.517.916-1.714 0-2.236l-6.124-3.5C13.037 11.369 12 11.95 12 13v6.999zM13 13c0-.196.102-.308.245-.308.059 0 .125.019.193.058l6.124 3.5c.242.138.236.365 0 .501l-6.124 3.499c-.242.138-.438.02-.438-.251V13z"
    />
  );
};

FiletypeVideoPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeVideoPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-video.jsx